@if (isLoading) {
  <loading class="tw-flex tw-justify-center tw-h-full"
  ></loading>
}

@if (!isLoading) {
  @if(newDoctorNoteUI) {
    <div (click)="back()" class="tw-fixed tw-left-0 tw-top-0 tw-right-0 tw-z-20" style="background: linear-gradient(180deg, rgba(244,255,252,1) 0%, rgba(244,255,252,1) 46%);">
      <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-relative tw-py-6">
        @if (isHairRegimen) {
          <h1 class="tw-text-400 tw-font-bold" i18n="@@myHairRoutine">My Hair Routine</h1>
        } @else {
          <h1 class="tw-text-400 tw-font-bold" i18n="@@mySkinRoutine">My Skin Routine</h1>
        }
        <cs-icon class="tw-text-black tw-h-6 tw-w-6 tw-absolute tw-left-4 tw-top-1/2 -tw-translate-y-1/2" [iconName]="'arrow_back'"></cs-icon>
      </div>
    </div>
  } @else {
    <div (click)="back()"
      class="tw-fixed tw-left-4 tw-top-6 tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-3 tw-z-20">
      <cs-icon class="tw-text-white tw-h-6 tw-w-6"
      [iconName]="'arrow_back'"></cs-icon>
    </div>
  }

  @if(newDoctorNoteUI) {
    @if (showDoctorNoteBanner) {
      <div class="tw-italic tw-bg-[#FFF2E3] tw-pl-4 tw-pt-4 tw-rounded-4 tw-mx-4 tw-mb-4 tw-mt-18 tw-relative">
        @if (isHairRegimen) {
          <h1 class="tw-text-200 tw-font-bold tw-mb-2 tw-text-orange-400" i18n="@@noteFromHairSpecialist">Note from your hair specialist</h1>
        } @else {
          <h1 class="tw-text-200 tw-font-bold tw-mb-2 tw-text-orange-400" i18n="@@noteFromSkinSpecialist">Note from your skin specialist</h1>
        }
        <div class="tw-flex tw-justify-between tw-items-end">
          <div class="tw-w-[70%] sm:tw-w-[65%] lg:tw-w-[70%] tw-pb-4">
            <p class="tw-italic tw-text-300">“<span class="tw-capitalize">{{ username }}</span>, <span class="tw-italic tw-text-300" [innerHTML]="doctorNoteMessage"></span>”</p>
          </div>
        </div>
        <div class="tw-max-w-[33%] sm:tw-max-w-[35%] lg:tw-max-w-[28%] tw-absolute tw-bottom-0 tw-right-0">
          <img class="tw-w-full tw-object-cover" [src]="allocatedDoctor.DoctorImageThumbnail" alt="Doctor">
        </div>
      </div>
    }
  } @else {
    <section class="tw-text-200 tw-mx-4 tw-mt-20">
      <p>
        <span i18n="@@personalisedFor">Personalised For</span>:&nbsp;
        <span class="tw-font-bold tw-capitalize">{{user.get('PatientName')?.split(' ')[0]}}, {{user.get('Age')}}
        years</span>
      </p>
      @if (regimen?.displayConcern?.name) {
        <p>
          <span i18n="@@treatmentGoal">Treatment Goal</span>:&nbsp;
          <span class="tw-font-bold">{{regimen?.displayConcern.name}}</span>
        </p>
      }
      @if (regimen?.displayConcern?.otherGoals) {
        <p
          class="tw-text-gray-400 tw-italic">
          @if (regimen?.displayConcern?.name) {
            <span i18n="@@otherGoals">Other Goals</span>
          }
          @if (!regimen?.displayConcern?.name) {
            <span i18n="@@treatmentGoal">Treatment Goal</span>
            }:&nbsp;
            <span>{{regimen?.displayConcern?.otherGoals}}</span>
          </p>
        }
      </section>
    }

    <!-- Divider -->
    @if (!newDoctorNoteUI) {
      <div class="tw-bg-black tw-opacity-10 tw-h-[1px] tw-mx-4 tw-my-2"></div>
    }

    @if (allocatedDoctor && !newDoctorNoteUI) {
      <section
        (click)="doctorCardClick()"
        class="tw-flex tw-items-end tw-gap-2 tw-mx-4 tw-mb-6">
        <div class="tw-h-10 tw-w-10 tw-rounded-full tw-bg-gray-300 tw-overflow-hidden">
          <img class="tw-max-w-full tw-max-h-full"
            [src]="allocatedDoctor.doctorDisplayImage">
        </div>
        <div class="tw-flex tw-flex-col tw-text-100 tw-gap-0.5">
          @if (isHairRegimen) {
            <h3 class="tw-text-orange-500 tw-font-bold tw-uppercase" i18n="@@yourHairSpecialist"> Your hair specialist </h3>
          } @else {
            <h3 class="tw-text-orange-500 tw-font-bold tw-uppercase" i18n="@@yourSkinSpecialist2"> Your skin specialist </h3>
          }
          <p>{{allocatedDoctor.DoctorDisplayName}}</p>
        </div>
      </section>
    }

    <!-- Product card -->
    @for (product of products; track $index) {
      <section [id]="'product-' + product.product?.objectId" class="tw-bg-white tw-rounded-4 tw-border tw-border-gray-200 tw-p-4 tw-mx-4 tw-mb-4" [ngClass]="(!showDoctorNoteBanner && newDoctorNoteUI) && $index === 0 ? 'tw-mt-20' : ''">
        <!-- header -->
        <div class="tw-flex tw-items-center tw-text-200 tw-mb-4">
          <h2 class="tw-uppercase tw-font-bold tw-mr-4">
            <span>{{$index + 1}}.</span>&nbsp;<span>{{product.product?.purpose}}</span>
          </h2>
          @if (product?.use.includes('morning')) {
            <div
              class="tw-flex tw-items-center tw-gap-1 tw-mr-2">
              <cs-icon class="tw-h-4 tw-w-4"
              [iconName]="'light_full'"></cs-icon>
              <span i18n="@@morning"> Morning </span>
            </div>
          }
          @if (product?.use.includes('night')) {
            <div
              class="tw-flex tw-items-center tw-gap-1">
              <cs-icon class="tw-h-4 tw-w-4"
              [iconName]="'night_full'"></cs-icon>
              <span i18n="@@night"> Night </span>
            </div>
          }
        </div>
        <!-- Images -->
        <div class="tw-mb-6 tw-overflow-hidden tw-flex tw-items-center tw-gap-3 -tw-mx-4">
          @if (product.images.length === 1) {
            <div
              class="tw-h-[220px] tw-w-auto tw-overflow-hidden tw-rounded-4 tw-bg-gray-100 tw-relative tw-mx-4">
              <div class="tw-absolute tw-top-2 tw-left-2 tw-bg-white tw-rounded-4 tw-px-1.5 tw-z-10">
                <p class="tw-text-100">{{product.product?.quantity}} {{product.product?.quantityUnit}}</p>
              </div>
              <img [src]="product.images[0].url"
                class="tw-h-full tw-w-auto"
                (click)="openSlideShow(product)">
            </div>
          }
          @if (product.images.length != 1) {
            <swiper
              [config]="swiperConfig">
              @for (object of product.images; track $index; let first = $first; let last = $last;) {
                <div *swiperSlide>
                  <div class="tw-h-auto tw-overflow-hidden tw-rounded-4 tw-bg-gray-100 tw-relative tw-mx-2">
                    @if ($index === 0) {
                      <div
                        class="tw-absolute tw-top-2 tw-left-2 tw-bg-white tw-rounded-4 tw-px-1.5 tw-z-10">
                        <p class="tw-text-100">{{product.product?.quantity}} {{product.product?.quantityUnit}}</p>
                      </div>
                    }
                    <img [src]="object.url"
                      class="tw-h-auto tw-w-auto"
                      (click)="openSlideShow(product)">
                  </div>
                </div>
              }
            </swiper>
          }
        </div>
        <!-- Content -->
        <div [ngClass]="{'tw-mb-6': product?.video}">
          <h1 class="tw-text-500 tw-font-bold tw-mb-2">{{product.product?.title}}</h1>
          <p class="tw-text-200 tw-text-gray-500 tw-mb-4">{{product.product?.description}}</p>
          @if (product?.product?.productHighlights?.length && product?.product?.productHighlights[0]?.image) {
            <div
              class="tw-flex tw-gap-2 tw-mb-4 tw-text-200">
              @for (highlight of product?.product?.productHighlights; track $index) {
                <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
                  <div class="tw-h-10 tw-w-10">
                    <img class="tw-h-full tw-w-full"
                         [src]="highlight?.image">
                  </div>
                  <p [innerHTML]="highlight?.description"></p>
                </div>
              }
            </div>
          }
          @if (product.ingredientsText) {
            @if(product.ingredientsText) {
              <div class="tw-bg-gray-100 tw-rounded-1 tw-p-2">
                <p class="tw-text-200 tw-text-gray-500 tw-italic"><span i18n="@@keyIngridents">Key Ingredients</span>:&nbsp;
                  <span>{{ product.ingredientsText }}</span>
                </p>
              </div>
            }
          } @else {
            @if (product.product?.ingredients && !product.product?.ingredients?.keyActive) {
              <div
                class="tw-bg-gray-100 tw-rounded-1 tw-p-2">
                <p class="tw-text-200 tw-text-gray-500 tw-italic"><span i18n="@@keyIngridents">Key Ingredients</span>:&nbsp;
                  {{product.product?.ingredients}}</p>
              </div>
            }
            @if (product.product?.ingredients?.keyActive) {
              <div
                class="tw-bg-gray-100 tw-rounded-1 tw-p-2">
                <p class="tw-text-200 tw-text-gray-500 tw-italic"><span i18n="@@keyIngridents">Key Ingredients</span>:&nbsp;
                  {{product.product?.ingredients?.keyActive}}</p>
              </div>
            }
          }
        </div>
    <!-- Footer -->
    @if (product?.video) {
      <div class="tw-flex tw-items-center tw-gap-2 tw-relative shine loop"
        (click)="openVideoPlayer(product?.video)">
        <p class="tw-text-teal-600 tw-font-bold tw-text-300" i18n="@@seeHowToApply">See how to apply</p>
        <cs-icon class="tw-h-7 tw-w-7"
        [iconName]="'play-icon-teal'"></cs-icon>
      </div>
    }
  </section>
}

@if (newDoctorNoteUI) {
  <section class="tw-text-200 tw-mx-4 tw-mb-4">
    <p>
      <span i18n="@@personalisedFor">Personalised For</span>:&nbsp;
      <span class="tw-font-bold tw-capitalize">{{user.get('PatientName')?.split(' ')[0]}}, {{user.get('Age')}}
      years</span>
    </p>
    @if (regimen?.displayConcern?.name) {
      <p>
        <span i18n="@@treatmentGoal">Treatment Goal</span>:&nbsp;
        <span class="tw-font-bold">{{regimen?.displayConcern.name}}</span>
      </p>
    }
    @if (regimen?.displayConcern?.otherGoals) {
      <p
        class="tw-text-gray-400 tw-italic">
        @if (regimen?.displayConcern?.name) {
          <span i18n="@@otherGoals">Other Goals</span>
        }
        @if (!regimen?.displayConcern?.name) {
          <span i18n="@@treatmentGoal">Treatment Goal</span>
          }:&nbsp;
          <span>{{regimen?.displayConcern?.otherGoals}}</span>
        </p>
      }
    </section>
  }
  @else {
  <!--  Doctor's note banner-->
  @if (showDoctorNoteBanner) {
    <div class="tw-w-full tw-mb-4 tw-bg-[#FFF2E3] tw-px-6 tw-pt-4 tw-pb-3 tw-text-center tw-flex tw-flex-col tw-justify-center tw-items-center">
      @if (user.get('languagePreference') !== appConfig.Shared.Languages.HI) {
        <h1 class="tw-font-semibold tw-text-300 tw-mb-3">Your skin specialist says...</h1>
      }
      @if (user.get('languagePreference') === appConfig.Shared.Languages.HI) {
        <h1 class="tw-font-semibold tw-text-300 tw-mb-3">आपके स्किन स्पेशलिस्ट कहते हैं...</h1>
      }
      <div class="tw-bg-white tw-rounded-3 tw-px-3 tw-pt-4 tw-pb-12">
        <p class="tw-italic tw-text-300">“<span class="tw-capitalize">{{ username }}</span>, <span class="tw-italic tw-text-300" [innerHTML]="doctorNoteMessage"></span>”</p>
      </div>
      <div class=" tw-flex tw-flex-col tw-justify-center tw-items-center -tw-mt-8">
        <div class="tw-h-16 tw-w-16 tw-rounded-full tw-overflow-hidden tw-mb-2 tw-bg-white tw-p-0.5">
          <img class="tw-max-w-full tw-max-h-full" [src]="allocatedDoctor.doctorDisplayImage" alt="Doctor">
        </div>
        <p class="tw-text-200">{{allocatedDoctor.DoctorDisplayName}}</p>
        <p class="tw-text-200 tw-italic tw-text-gray-700 tw-flex tw-items-start tw-lowercase -tw-mt-0.5">{{ formattedDate.date }}<span class="tw-text-50 -tw-mt-[1px] tw-mr-1">{{ getOrdinalSuffix(formattedDate.date) }}</span> {{ formattedDate.month }}, {{ formattedDate.time }}</p>
      </div>
    </div>
  }
}

<div [ngClass]="!newDoctorNoteUI && showDoctorNoteBanner ? 'tw-h-14' : 'tw-h-20'"></div>
<div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-bg-[#ffffffcc] tw-backdrop-blur-md">
  <div class="tw-flex tw-items-center tw-gap-4 tw-p-4">
    <div class="tw-flex-1">
      <cs-button class="tw-border tw-rounded-full w100 purple btn-xs tw-border-teal-600 tw-text-teal-600"
        [disabled]="isInternalUser"
        (callback)="readInstructions()">
        <cs-button-text i18n="@@getInstructions">Get Instructions</cs-button-text>
      </cs-button>
    </div>
    @if (!regimen.active && !regimen.orderPlaced) {
      <div class="tw-flex-1"
        >
        <cs-button id="buyNowButton"
          class="tw-bg-teal-600 tw-rounded-full shine loop w100 primary shine btn-xs"
          [disabled]="isInternalUser"
          (callback)="buyRegimen()">
          <cs-button-text i18n="@@buyNow">Buy Now</cs-button-text>
        </cs-button>
      </div>
    }
  </div>
</div>
}
